import { getRuntimeConfig } from "common/lib/runtimeConfig"

export const isDevelopment = () => getRuntimeConfig().APP_ENV === "development"
